import { Box, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import ProgressIcon from 'assets/icons/Progress.svg?react';
import { CaseStatusDetail, CaseStatusType } from 'pco-product-service-internal-consumer';
import CaseStatusStepper from 'views/Case/CaseStatusStepper';

const styles = {
  card: {
    maxWidth: '90%',
  },
  container: {
    paddingLeft: theme.spacing(2),
  },
  icon: {
    marginTop: theme.spacing(2),
  },
  cardHeader: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  textContainer: {
    display: 'grid',
    paddingRight: 0,
    marginRight: theme.spacing(2),
  },
};

type Props = {
  status?: CaseStatusDetail;
};
export const CaseStatus = ({
  status = {
    activeStep: CaseStatusType.PROPOSAL_CREATED,
    statuses: [],
    initiatedBy: '',
  },
}: Props) => {
  return (
    <Card data-testid="case-status" sx={styles.card} square>
      <Grid container sx={styles.container}>
        <ProgressIcon style={styles.icon} />
        <CardHeader title={'STATUS'} titleTypographyProps={{ variant: 'subtitle1' }} sx={styles.cardHeader} />
      </Grid>
      <CardContent
        style={{
          paddingTop: theme.spacing(0),
          paddingBottom: theme.spacing(1),
        }}
      >
        <CaseStatusStepper
          activeStep={status.activeStep ?? CaseStatusType.PROPOSAL_CREATED}
          dates={(status.statuses ?? []).map((x) => (x.date ? x.date.toISOString() : ''))}
        />

        {status?.initiatedBy && (
          <Box sx={styles.textContainer}>
            <>
              <Typography variant={'caption'} style={{ marginTop: theme.spacing(2) }}>
                Initiated by
              </Typography>
              <Typography variant={'body1'} style={{ fontWeight: 600 }}>
                {status.initiatedBy}
              </Typography>
            </>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
